module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"questionNotSaved":"Вы не сохранили вопрос","continue":"Продолжить редактирование","done":"Готово"}}')
  delete Component.options._Ctor
}
